import Box from '@mui/material/Box';
import { Container } from '@mui/material';
import './../style/css/aboutUs.css'
import Card1 from '../assets/images/AboutPage/about us/about us -2.png'
import Card3 from '../assets/images/AboutPage/about us/about us -4.png'
import Card2 from '../assets/images/AboutPage/about us/about us -3.png'
import aboutus from '../assets/images/AboutPage/about us/about us -5.png'
import { ourMissionData } from '../constant/constant'
function OurVisionMission() {
    return (
        <>
            <Box>
                <div className="pt-5">
                    <div className="chapter-heading">
                        <h2 className="text-center title-font text-light py-3 mt-1">Our Vision & Mission</h2>
                    </div>
                </div>
                <div id='vision' className='p-md-5 p-3 overallPadding'>
                    <div className='d-flex align-items-center'>
                        <h4 className='mt-2  ms-4 title-font fw-bold' style={{ color: "#611f1e", fontSize: "30px !imporant" }}>Our Vision</h4>
                        <hr className='gallery-hori ms-1' style={{ width: "80%" }} />
                    </div>
                    <div className='mb-3'>
                        <Container maxWidth="xl" className='mt-5 mb-5'>
                            <div className='row  mt-5 mb-3 content-font'>
                                <div className='col-md-4  mt-5 '>
                                    <div className='d-flex justify-content-center about-us-page-card1-containter'>
                                        <div className='about-us-page-card1 '> <img src={Card1} alt='card1' /></div>
                                    </div>
                                    <div className=' p-5 h-100 about-us-page-card1-caption'>
                                        <p>To make India a hub of ELT-related activities and to conceptualise the experiences of practitioners in teaching and learning the English language and symbiotically share them with others.</p>
                                    </div>
                                </div>
                                <div className='col-md-4 mt-5 about_vision'>
                                    <div className='d-flex justify-content-center about-us-page-card2-containter'>
                                        <div className='about-us-page-card2 '> <img src={Card2} alt="card2" /></div>
                                    </div>
                                    <div className=' p-5 h-100 about-us-page-card2-caption'>
                                        <p>To develop into a movement spreading across the length and breadth of the country empowering teachers to make every learner of English globally competitive.</p>
                                    </div>
                                </div>
                                <div className='col-md-4 mt-5 about_vision'>
                                    <div className='d-flex justify-content-center about-us-page-card3-containter'>
                                        <div className='about-us-page-card3  '> <img src={Card3} alt="card3" /></div>
                                    </div>
                                    <div className=' p-5 h-100 about-us-page-card3-caption'>
                                        <p>To become a recognized leader, a catalyst, a facilitator, and a trendsetter in spreading English literacy across the country.</p>
                                    </div>
                                </div>
                            </div>
                        </Container>
                    </div>
                </div>
                <div className='container-fluid p-md-5 p-3 overallPadding' id='mission'>
                    <div className='row mb-5'>
                        <div className='col-md-8 mt-5'>
                            <Container maxWidth="xl">
                                <div className='col-sm-12' >
                                    <div className='d-flex align-items-center' >
                                        <h4 className='mt-2  ms-2 title-font fw-bold' style={{ color: "#611f1e", fontSize: "30px !imporant" }}>Our Mission</h4>
                                        <hr className='gallery-hori ms-1' style={{ width: "75%" }} />
                                    </div>
                                    <div className="content-font">
                                        {ourMissionData.map((data, i) => {
                                            return (<div key={data.id}>
                                                <div className='row mt-3 '>
                                                    <div className='col-2  '><img src={data.img} width={"45px"} alt='icon' /></div>
                                                    <div className='col-10 mt-2 '><p className="text-dark about-us-icon-caption">{data.caption} </p></div>
                                                </div>
                                            </div>)
                                        })}</div>
                                </div>

                            </Container>
                        </div>
                        <div className='col-md-4 mt-5'>
                            <img src={aboutus} width={"100%"} alt="banner-img" className='h-auto' />
                        </div>
                    </div>


                </div>

            </Box>
        </>

    );
}

export default OurVisionMission;
